define('plugins/musicfavourite/user',["require", "exports", "idcta/idcta-1"], function (require, exports, idcta) {
    "use strict";
    exports.__esModule = true;
    function isSignedIn() {
        return idcta.hasCookie();
    }
    exports.isSignedIn = isSignedIn;
    function refreshTokens() {
        var FORCE = false;
        var HOSTNAME = 'bbc.co.uk';
        return idcta.initiateTokenRefresh(FORCE, HOSTNAME);
    }
    exports.refreshTokens = refreshTokens;
});
//# sourceMappingURL=user.js.map;
